package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class UserDto(
    val id: String,
    val email: String,
    val username: String,
    val fullName: String? = null,
    val avatarUrl: String? = null,
    val isActive: Boolean? = null,
    val isEmailVerified: Boolean? = null,
    val activeRole: String? = null,
    /**
     * Main card on the profile — the first entry (lowest `displayOrder`)
     * from the user's profile-card gallery. Backend sends this; the rest
     * of the gallery is fetched via the dedicated profile-cards endpoint.
     */
    val mainProfileCard: ProfileCardDto? = null,
    val bio: String? = null,
    val phone: String? = null,
    val city: String? = null,
    val country: String? = null,
    val dateOfBirth: String? = null,
    val languages: List<String> = emptyList(),
    val interestSports: List<String> = emptyList(),
    val interestActivities: List<String> = emptyList(),
    val interestLifestyle: List<String> = emptyList(),
    val interestNotes: Map<String, String> = emptyMap(),
    val createdAt: String? = null,
    val updatedAt: String? = null
)

@Serializable
data class UpdateUserRequest(
    val fullName: String? = null,
    val avatarUrl: String? = null,
    val bio: String? = null,
    val phone: String? = null,
    val city: String? = null,
    val country: String? = null,
    val dateOfBirth: String? = null,
    val languages: List<String>? = null,
    val interestSports: List<String>? = null,
    val interestActivities: List<String>? = null,
    val interestLifestyle: List<String>? = null,
    val interestNotes: Map<String, String>? = null
)

@Serializable
data class UpdateActiveRoleRequest(
    val role: String
)
